import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/Card';
import { TextField } from '@/components/ui/TextField';
import { Button } from '@/components/ui/Button';
import { Alert } from '@/components/ui/Alert';
import { useForgotPassword } from '@/auth/hooks';
import { errorMessage } from '@/lib/errorMessage';
import { ROUTES } from '@/lib/config';
import { useT } from '@/i18n/useT';
import { rules } from './rules';

export function ForgotPage() {
  const { t } = useT();
  const forgot = useForgotPassword();
  const [sent, setSent] = useState(false);
  const [serverError, setServerError] = useState('');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ email: string }>();

  const onSubmit = handleSubmit(async (data) => {
    setServerError('');
    try {
      await forgot.mutateAsync(data);
      setSent(true); // server answers identically whether or not the account exists
    } catch (e) {
      setServerError(errorMessage(e));
    }
  });

  return (
    <Card title={t('forgot.title')} subtitle={sent ? undefined : t('forgot.subtitle')}>
      {sent ? (
        <>
          <Alert kind="success">{t('forgot.sent')}</Alert>
          <Link className="link" to={ROUTES.login}>
            {t('forgot.backToLogin')}
          </Link>
        </>
      ) : (
        <>
          <Alert kind="error">{serverError}</Alert>
          <form onSubmit={onSubmit} noValidate>
            <TextField
              label={t('common.email')}
              type="email"
              autoComplete="email"
              autoFocus
              error={errors.email?.message}
              disabled={forgot.isPending}
              {...register('email', rules.email)}
            />
            <Button type="submit" busy={forgot.isPending}>
              {forgot.isPending ? t('forgot.working') : t('forgot.cta')}
            </Button>
          </form>
          <p className="foot">
            <Link className="link" to={ROUTES.login}>
              {t('forgot.backToLogin')}
            </Link>
          </p>
        </>
      )}
    </Card>
  );
}
